import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from "@/components/ui/chart";
import React from "react";
import { Area, AreaChart, CartesianGrid, XAxis } from "recharts";

interface MessagesByDay {
  date: string
  messages: number
  sent: number
  received: number
}

interface StatsWithAreaChartProps {
  data: MessagesByDay[]
  loading?: boolean
  totalMessages?: number
}

const chartConfig = {
  sent: {
    label: "Enviadas",
    color: "#353538",
  },
  received: {
    label: "Recebidas",
    color: "#A1A1AA",
  },
} satisfies ChartConfig;

const StatsWithAreaChart: React.FC<StatsWithAreaChartProps> = ({ 
  data, 
  loading = false, 
  totalMessages = 0 
}) => {
  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr)
    return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })
  }

  const chartData = data.map(item => ({
    date: formatDate(item.date),
    sent: item.sent,
    received: item.received,
    total: item.messages
  }))

  if (loading) {
    return (
      <div className="w-full flex flex-col gap-3 animate-pulse">
        <div className="h-6 bg-neutral-600 rounded w-1/2"></div>
        <div className="h-8 bg-neutral-600 rounded w-1/4"></div>
        <div className="h-[260px] bg-neutral-600 rounded"></div>
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col gap-3">
      <h2 className="text-neutral-100 font-semibold text-[20px]">
        Mensagens (7 dias)
      </h2>
      <h2 className="text-[30px] text-neutral-100 font-semibold">
        {totalMessages.toLocaleString()}
      </h2>
      <ChartContainer className="h-[260px] mt-2" config={chartConfig}>
        <AreaChart
          accessibilityLayer
          data={chartData}
          margin={{
            left: 0,
            right: 0,
          }}
        >
          <CartesianGrid vertical={true} horizontal={false}  stroke="#FAFAFA" opacity={.5} />
          <XAxis
            dataKey="date"
            tickLine={true}
            axisLine={false}
            tick={{ fill: "#FAFAFA" }}
            tickFormatter={(value) => value}
          />
          <ChartTooltip
            cursor={{ stroke: "#FAFAFA", strokeWidth:1 }}
            content={<ChartTooltipContent />}
          />
          <Area
            dataKey="received"
            type="natural"
            fill="var(--color-received)"
            fillOpacity={0.4}
            stroke="var(--color-received)"
            stackId="a"
          />
          <Area
            dataKey="sent"
            type="natural"
            fill="var(--color-sent)"
            fillOpacity={0.4}
            stroke="var(--color-sent)"
            stackId="a"
          />
        </AreaChart>
      </ChartContainer>
    </div>
  );
};

export default StatsWithAreaChart;
